import React from "react";
import { useSelector } from "react-redux";
import MicroComponents from "./MicroComponents";
import { AppState } from "../../../../../stateManager/store";
import { getComponents } from "../helpers/assetHelpers";

interface ISnackbarRender {
  deviceType: "Sm" | "Md" | "Lg";
}

export const SnackBarRenderer = (props: ISnackbarRender) => {
  const snackbar = useSelector((state: AppState) => state.formJson.snackbar);
  const { componentId, visible } = snackbar;
  const { components } = getComponents()
  const component = components[componentId]

  if (!visible || !component) {
    return null;
  }

  return <MicroComponents element={component} deviceType={props.deviceType} />;
};
